// ============================================================
// SAC - Page "Attribuées au répartiteur" (workflow=attribuee_repartiteur)
// ------------------------------------------------------------
// Commandes deja passees au dispatch. Vue de suivi pour l'agent
// logistique qui les a transmises. Etape 3 sur 3.
// ============================================================
import React from 'react';
import { Inbox, CalendarCheck2, Users, Route } from 'lucide-react';
import SacGridView from '../components/SacGridView';

const SAC_TABS = [
  { href: '/admin/service-client/a-planifier', label: 'RDV à planifier', icon: Inbox, active: false },
  { href: '/admin/route-optimisation',         label: 'Route Optimisation', icon: Route, active: false },
  { href: '/admin/service-client/planifies',   label: 'RDV planifiés',   icon: CalendarCheck2, active: false },
  { href: '/admin/service-client/attribuees',  label: 'Attribuées au répartiteur', icon: Users, active: true },
];

const SacAttribueesPage = () => (
  <SacGridView
    title="ATTRIBUÉES AU RÉPARTITEUR"
    subtitle="Vos commandes désormais entre les mains du dispatch — suivi lecture seule"
    iconLetters="SC"
    iconColor="emerald"
    workflowIn={['attribuee_repartiteur']}
    assignmentType={null}
    nextWorkflow={null}
    scopeMine
    subTabs={SAC_TABS}
    storageKey="sacGrid.attribuees"
  />
);

export default SacAttribueesPage;
